module.exports = __webpack_public_path__ + "img/tuerueberdachung_1.44dccb97.webp";